import { render } from "./QuillEditor.vue?vue&type=template&id=fe4a99d6&scoped=true"
import script from "./QuillEditor.vue?vue&type=script&lang=js"
export * from "./QuillEditor.vue?vue&type=script&lang=js"

import "./QuillEditor.vue?vue&type=style&index=0&id=fe4a99d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe4a99d6"]])

export default __exports__